import { Controller } from '@hotwired/stimulus'
import { loadSwiper } from 'utils/loadSwiper'

export default class extends Controller {
  static targets = ['slider', 'next', 'prev']

  connect() {
    const sliderElement = this.sliderTarget
    if (!sliderElement) return

    this.observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return

          obs.disconnect()

          loadSwiper().then(({ Swiper, Navigation }) => {
            Swiper.use([Navigation])

            new Swiper(sliderElement, {
              spaceBetween: 8,
              slidesPerView: 1.1,
              disabledClass: 'disable',
              navigation: {
                nextEl: this.nextTarget,
                prevEl: this.prevTarget
              },
              breakpoints: {
                550: {
                  slidesPerView: 2,
                  spaceBetween: 32
                },
                900: {
                  slidesPerView: 3,
                  spaceBetween: 32
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 32
                }
              }
            })
          })
        })
      },
      { rootMargin: '200px' }
    )

    this.observer.observe(sliderElement)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
